module.exports = __webpack_public_path__ + "fonts/5fecc99e63d74a353d6eaacb6e89778d.svg";